/**
 * Application helper module
 *
 * @module helpers/application
 */
define('helpers/application',['require','jquery','underscore','ejs','chaplin','config/application','lib/utils'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        ejs = require('ejs'),
        Chaplin = require('chaplin'),
        applicationConfig = require('config/application'),
        utils = require('lib/utils');

    /**
     * Application helper object
     * Consist of app help functions can be used in any place
     *
     * @class applicationHelper
     * @static
     */
    return {
        publicName: applicationConfig.title,
        /**
         * Building url on routes
         *
         * @method url
         * @param {string} routeName - depends on config/routes
         * @see Chaplin.helpers.reverse
         */
        url: function(routeName, params, query) {
            try {
                var u = Chaplin.helpers.reverse(routeName, params, query).replace(/^\//, '#').replace(/\/$/, '');
                // console.log('URL', routeName, params, query, '=>', u);
                return u;
            } catch(e) {
                console.error(e);
                return '';
            }
        },

        pageUrl: function(pageName, options) {

            if (options && options.roles){
                if (!Chaplin.mediator.user.hasRoles(options.roles)) {
                    return '';
                }
            }
            var _pageName = pageName;
            if (pageName === 'account-order'){
                _pageName = 'requests';
            }

            var page = Chaplin.mediator.pages.findWhere({ name: _pageName });

            return page ? this.url(page.get('action')) : '';
        },
        /**
         * Make redirect to another route
         *
         * @method redirectTo
         * @see Chaplin.helpers.redirectTo
         */
        redirectTo: function() {
            Chaplin.helpers.redirectTo.apply(this, arguments);
        },
        /**
         * Rendering template based on path and data
         * Tempate should be required before using here so
         * require won't be async
         *
         * @method render
         * @param {string} path - get template by this path
         * @param {object} data - object with data to render
         */
        render: function(path, data) {
            var template = require('text!templates/' + path + '.ejs');
            return ejs.compile(template)(data);
        },

        renderTmpl: function(selector, data) {
            var template = $(selector).text();
            return ejs.compile(template)(data);
        },

        objectToCSS: utils.objectToCSS,
        money: utils.money,
        date: utils.date,
        dateJs: utils.dateJs,
        fileSize: utils.fileSize,
        unitToText: utils.unitToText,
        unitToText2: utils.unitToText2,
        fmtDate: utils.fmtDate,
        fmtDisplayDate: utils.fmtDisplayDate,

        apiRoot: function() {
            return utils.getApiRoot();
        },

        apiUrl: function(routeName, query){
            return utils.getApiUrl(routeName, query);
        },

        requestStateCode: function(state) {
            var stateCodeMap = {
                '-1': 'wait',
                '1': 'ok',
                '0': 'decline',
                '2': 'replace',
                '3': 'search'
            };
            return stateCodeMap[state];
        },

        requestStateIcon: function(state) {
            var stateIconMap = {
                '-1': 'icon-repeat',
                '1': 'icon-check',
                '0': 'icon-remove',
                '2': 'icon-refresh',
                '3': 'icon-question-sign'
            };
            return stateIconMap[state];
        },

        requestStateName: function(state) {
            var stateNameMap = {
                '-1': 'Заказ',
                '1': 'Ок',
                '0':  'Отказ',
                '2': 'Замена',
                '3': 'Поиск'
            };
            return stateNameMap[state];
        },

        requestStatusIcon: function(state) {
            var stateIconMap = {
                'wait': 'icon-repeat',
                'ok': 'icon-check',
                'decline':  'icon-remove',
                'relace': 'icon-refresh',
                'search': 'icon-question-sign'
            };
            return stateIconMap[state];
        },

        requestStatusName: function(state) {
            var stateNameMap = {
                'wait': 'Заказ',
                'ok': 'Ок',
                'decline':  'Отказ',
                'relace': 'Замена',
                'search': 'Поиск'
            };
            return stateNameMap[state];
        },

        freshnessName: function(freshness) {
            var map = [
                'оч. плохо',
                'плохо',
                'средне',
                'хорошо',
                'отлично'
            ];
            return map[parseInt(freshness, 10)-1] || '';
        },

        qualityName: function(quality) {
            var map = [
                'оч. плохо',
                'плохо',
                'средне',
                'хорошо',
                'отлично'
            ];
            return map[parseInt(quality, 10)-1] || '';
        },

        transformMessage: utils.transformMessage,
        datetime: utils.datetime,

        isAuthorized: function() {
            return Chaplin.mediator.isAuthorized();
        },

        isDemo: function() {
            return Chaplin.mediator.isDemo();
        },

        isClientSB: function() {
            return Chaplin.mediator.user && Chaplin.mediator.user.isClientSB();
        },

        showDemoDialog: function() {
            if (Chaplin.mediator.isDemo()) {
                return 'onclick="app.onShowDemoDialog(event);"';
            } else {
                return '';
            }
        },

        execute: function(eventName, params) {
            return 'require("mediator").execute("' + eventName + '", ' + JSON.stringify(params) + ')';
        },

        getRequestStatusName: function(status) {
            var statuses = {
                'requested': 'Заказано',
                'processing': 'Обработка',
                'declined': 'Отмена',
                'check': 'Проверка',
                'ok': 'Ок',
                'confirmed': 'Подтверждено'
            };
            return statuses[status] || status || '';
        },

        getRequestStatusLabel: function(status) {
            var statuses = {
                'requested': '',
                'processing': 'label-info',
                'declined': 'label-danger',
                'check': 'label-warning',
                'ok': 'label-primary',
                'confirmed': 'label-success'
            };
            return statuses[status] || status || '';
        }
    };

});
